const styles = () => ({
  tools: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    marginTop: 20,
    color: '#000',
    marginBottom: 10,
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10,
    width: '48%',
  },
  button: {
    margin: 0,
    width: 70,
  },
  areaField: {
    width: '100%',
    margin: 0,
    verticalAlign: 'center',
  },
  buttonsWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  mezzoButtons: {
    margin: '0 20px 0 0',
    textTransform: 'none',
    fontSize: '14px',
  },
  clearPopup: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: '999',
    background: 'rgba(255, 255, 255, 0.7)',
  },
  clearPopupMain: {
    background: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: 20,
    margin: 12,
    border: '1px solid rgba(0, 0, 0, 0.2)',
    borderRadius: 5,
  },
  popupTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: 20,
  },
  popupMessage: {
    fontSize: 16,
    padding: '0 12px',
    marginBottom: 20,
  },
  popupButtonsWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  popupButtons: {
    width: 100,
    height: 36,
    margin: '0 5px',
  },
  '@media (max-width: 640px)': {
    tools: {
      flexDirection: 'column',
    },
    buttonWrapper: {
      width: '100%',
    },
    buttonsWrapper: {
      flexDirection: 'column',
      alignItems: 'center',
    },
    mezzoButtons: {
      width: '100%',
      margin: '0 0 10px 0',
    },
  },
})

export default styles
